import { c as _c } from "react-compiler-runtime";
import { useMemo } from 'react';
import useCrmSearchQuery from 'framework-listing-lib/hooks/useCrmSearchQuery';
import useFetcher from './useFetcher';
import { useCrmObjectType } from '../providers/CrmObjectTypeListingClientProvider';
export default function useCrmObjectTypeFetchParams(t0) {
  "use memo";

  const $ = _c(7);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {
      includeHiddenFilter: true
    } : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const args = t1;
  const crmSearchQuery = useCrmSearchQuery(args);
  const fetcher = useFetcher();
  const {
    associationSpecs,
    fetcherKey
  } = useCrmObjectType();
  let t2;
  if ($[2] !== associationSpecs || $[3] !== crmSearchQuery || $[4] !== fetcher || $[5] !== fetcherKey) {
    t2 = {
      associationSpecs,
      fetcher,
      fetcherKey,
      fetchParams: crmSearchQuery
    };
    $[2] = associationSpecs;
    $[3] = crmSearchQuery;
    $[4] = fetcher;
    $[5] = fetcherKey;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const variables = t2;
  const value = variables;
  return value;
}